import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'thresholdLabel',
  standalone: true,
})
export class ThresholdLabelPipe implements PipeTransform {
  transform(threshold: number, tabs: {label: string; value: number}[]): string {
    return tabs.find(t => t.value === threshold)?.label ?? '';
  }
}
